import * as React from 'react';
import { IgcBadgeComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The badge is a component indicating a status on a related item or an area
 * where some active indication is required.
 * @slot  - Default slot for the badge content.
 * @csspart base - The base wrapper of the badge.
 * @csspart icon - The icon container, present when an igc-icon element is slotted.
 * @class
 */
export const IgrBadge = /* @__PURE__ */ createComponent({
  tagName: 'igc-badge',
  displayName: 'IgrBadge',
  elementClass: Component,
  react: React,
});

export type IgrBadge = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrBadgeModule = Component;
